import service from '@/services/superaccess'

const manufacturer = {
  state: {
    modal: false
  },
  mutations: {
    updateStatusManufacturerModal (state, status) {
      state.modal = status
    }
  },
  getters: {
    getStatusManufacturerModal (context) {
      return context.modal
    }
  },
  actions: {
    retrieveManufacturers (context, payload) {
      return service.post('/api/camera/manufacturer/all', context, payload)
    },
    setStatusManufacturerModal (context, payload) {
      context.commit('updateStatusManufacturerModal', payload)
    },
    addManufacturer (context, payload) {
      return service.post('/api/camera/manufacturer/create_manufacturer', context, payload)
    },
    modifyManufacturer (context, payload) {
      return service.post('/api/camera/manufacturer/modify', context, payload)
    },
    inactivateManufacturer (context, payload) {
      return service.post('/api/camera/manufacturer/inactivate', context, { id: payload.manufacturer, state: payload.state })
    }
  }
}

export default manufacturer



// WEBPACK FOOTER //
// app/javascript/src/store/manufacturer.js